import { render, staticRenderFns } from "./ProductBrandsModal.vue?vue&type=template&id=f4954774&scoped=true&"
import script from "./ProductBrandsModal.vue?vue&type=script&lang=ts&"
export * from "./ProductBrandsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBrandsModal.vue?vue&type=style&index=0&id=f4954774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4954774",
  null
  
)

export default component.exports